"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderUnit = void 0;
const react_1 = require("react");
const compiler_1 = require("../modules/compiler");
function useRenderUnit(spuMeta, paramKeyList, description) {
    const renderUnitBuilder = (0, react_1.useMemo)(() => (0, compiler_1.renderUnitBuilderFactory)(spuMeta), [spuMeta]);
    const renderUnitList = (0, react_1.useMemo)(() => renderUnitBuilder(paramKeyList, description), [description, paramKeyList, renderUnitBuilder]);
    return renderUnitList;
}
exports.useRenderUnit = useRenderUnit;
